import {
  DataModuleVO,
  DataWorkshopEntity,
  DataWorkshopEntityId,
} from '@edgvr-front/data/domain';
import { createAction, props } from '@ngrx/store';

export const init = createAction('[Data Workshop / Modules List Page] Init');
export const destroy = createAction(
  '[Data Workshop / Modules List Page] Destroy'
);

export const selectedDataWorkshopSet = createAction(
  '[Data Workshop / Modules List Page] Selected Data Workshop Set',
  props<{ dataWorkshop: DataWorkshopEntity }>()
);
export const selectedDataModuleSet = createAction(
  '[Data Workshop / Modules List Page] Selected Data Module Set',
  props<{ dataModule: DataModuleVO }>()
);

export const dataWorkshopGet = createAction(
  '[Data Workshop / Modules List Page] Data Workshop Get',
  props<{ id: DataWorkshopEntityId }>()
);
export const dataWorkshopGetSuccess = createAction(
  '[Data Workshop / Modules List Page] Data Workshop Get Success',
  props<{ dataWorkshop: DataWorkshopEntity }>()
);
